<template>
    <div class="question-checkbox-type">
        <div v-if="hasError">
            <b-alert show variant="danger">{{ errorText}} </b-alert>
        </div>
        <b-form-group
            id="custom-form-question-checkbox-group"
            label-for="custom-form-question-checkbox">
            <template v-slot:label>
                {{ questionIn.text }}: <span class="required" v-if="questionIn.required">*</span>
            </template>

            <b-form-checkbox
                v-if="questionIn.options.length === 1"
                :checked="value"
                :value="questionIn.options[0].id"
                @input="update"
            >
                {{questionIn.options[0].text}}
            </b-form-checkbox>

            <b-form-checkbox-group
                v-else
                class="apprentice-checkbox"
                name="custom-form-question-checkbox"
                value-field="id"
                text-field="text"
                :checked="value"
                :options="questionIn.options"
                @input="update">
            </b-form-checkbox-group>
        </b-form-group>
    </div>
</template>

<script>
export default {
    name: "custom-form-create-question-checkbox-component",
    props: {
        questionIn: {
            type: Object,
            required: true,
        },
        hasError: {
            type: Boolean,
            required: false,
            default: false,
        },
        errorText: {
            type: String,
            required: false,
            default: 'Deze vraag is verplicht.'
        },
        value: {
            type: Array|Number,
        }
    },
    methods:{
        update(checked){
            this.$emit('update-answer', {
                questionId: this.questionIn.id,
                value: checked,
                isEmpty: !checked,
                type: 4
            });
        }
    }
}
</script>

<style scoped>

</style>
